import { LAYOUTS, POSITION } from "@voltmoney/types";
import { AspectRatioToken, BorderRadiusTokens, ColorTokens, FontDecorationToken, FontFamilyTokens, FontSizeTokens, GridItemTypeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, PromotionCardType, SizeTypeTokens, StackAlignItems, StackHeight, StackJustifyContent, StackType, StackWidth, TextAlignTokens, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { PartnerHeader } from "./partnerHeader";
import { ACTION } from "./types";
import { goToAccountDetails, goToMarketing, InviteClient, onChangeTab, onKnowMore, onLogoutPress, openMenu, promoBannerInvite, RegisterClient } from "./actions";
import { isMobile } from "../../configs/utils";
import { PartnerAccountType } from "../../configs/constants";
import { GoToFaq, GoToHome, GoToPhone, GoToWhatsapp } from "../../partnerWeb_Features/partnerSignUp/actions";
import { PlatformSideNav } from "../../partnerWeb_Features/sideNavBar/platformSideNav";
const _isMobile = isMobile();
const trackDashboardItem = [
    {
        name: 'Leads',
        icon: {
            name: IconTokens.Lead3,
            size: IconSizeTokens.XXXXXL
        },
        action: {
            routeId: ROUTE.PLATFORM_DASHBOARD,
            type: ACTION.CHANGE_TAB,
            payload: {
                routeId: ROUTE.PLATFORM_LEADS
            }
        }
    },
    {
        name: 'Active Customers',
        icon: {
            name: IconTokens.Customer3,
            size: IconSizeTokens.XXXXXL
        },
        action: {
            routeId: ROUTE.PLATFORM_DASHBOARD,
            type: ACTION.CHANGE_TAB,
            payload: {
                routeId: ROUTE.PLATFORM_ACTIVE_CUSTOMERS
            }
        }
    },
    {
        name: 'Partners',
        icon: {
            name: IconTokens.Partner3,
            size: IconSizeTokens.XXXXXL
        },
        action: {
            routeId: ROUTE.PLATFORM_DASHBOARD,
            type: ACTION.CHANGE_TAB,
            payload: {
                routeId: ROUTE.PLATFORM_LINKED_PARTNERS
            }
        }
    },
];
const startEarningItem = (_link, partnerAccountType) => {
    if (partnerAccountType && partnerAccountType !== PartnerAccountType.INDIVIDUAL) {
        return [
            {
                name: _isMobile ? 'Share unique link' : '  Share unique   link',
                icon: {
                    name: IconTokens.Share4,
                    size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
                },
                action: {
                    routeId: ROUTE.PARTNER_DASHBOARD_V2,
                    type: ACTION.INVITE_CLIENT,
                    payload: {
                        link: _link ? _link : ''
                    }
                }
            },
            {
                name: 'Marketing collaterals',
                icon: {
                    name: IconTokens.Megaphone,
                    size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
                },
                action: {
                    routeId: ROUTE.PARTNER_DASHBOARD_V2,
                    type: ACTION.MARKETING,
                    payload: {
                        routeId: ROUTE.COLLATERAL
                    }
                }
            },
        ];
    }
    return [
        {
            name: 'Register customer',
            icon: {
                name: IconTokens.ADD_FRIEND,
                size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
            },
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.REGISTER_CLIENT,
                payload: {}
            }
        },
        {
            name: _isMobile ? 'Share unique link' : '  Share unique   link',
            icon: {
                name: IconTokens.Share4,
                size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
            },
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.INVITE_CLIENT,
                payload: {
                    link: _link ? _link : ''
                }
            }
        },
        {
            name: 'Marketing collaterals',
            icon: {
                name: IconTokens.Megaphone,
                size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
            },
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.MARKETING,
                payload: {
                    routeId: ROUTE.COLLATERAL
                }
            }
        },
    ];
};
export const template = async () => ({
    layout: {
        id: ROUTE.PLATFORM_DASHBOARD,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: 'partnerHeader', type: WIDGET.STACK, position: POSITION.ABSOLUTE_TOP },
            _isMobile ? {} : { id: 'sideNav', type: WIDGET.STACK, position: POSITION.NAVBAR_LEFT },
            { id: 'partnerDashboardBody', type: WIDGET.STACK },
        ],
    },
    datastore: {
        partnerDashboardBody: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            padding: {
                top: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                right: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
            },
            widgetItems: [
                {
                    id: 'partnerDashboardBodyT1', type: WIDGET.TEXT
                },
                {
                    id: 'partnerDashboardSpace1', type: WIDGET.SPACE
                },
                {
                    id: 'partnerDashboardTrackStatusStack', type: WIDGET.STACK
                },
                {
                    id: 'partnerDashboardSpace7', type: WIDGET.SPACE
                },
            ],
        },
        partnerDasboardPayoutDetailStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            padding: {
                top: SizeTypeTokens.MD,
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                bottom: SizeTypeTokens.MD,
            },
            bgColor: ColorTokens.Primary_100,
            widgetItems: [
                { id: 'partnerDasboardPayoutDetailStackT1', type: WIDGET.TEXT },
                { id: 'partnerDasboardPayoutDetailStackS1', type: WIDGET.STACK },
            ]
        },
        partnerDasboardPayoutDetailStackS1: {
            type: StackType.row,
            widgetItems: [
                { id: 'partnerDasboardPayoutDetailStackT2', type: WIDGET.TEXT },
            ],
            action: {
                routeId: ROUTE.PLATFORM_DASHBOARD,
                type: ACTION.GO_TO_ACCOUNT_DETAIL,
                payload: {
                    routeId: ROUTE.MY_ACCOUNT,
                    params: 'payoutDetails'
                }
            }
        },
        partnerDasboardPayoutDetailStackT1: {
            label: `Complete your payout profile. `,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Milk,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: _isMobile ? 18 : 20,
        },
        partnerDasboardPayoutDetailStackT2: {
            label: `Start now`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Milk,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '700',
            lineHeight: _isMobile ? 18 : 20,
            textDecorationLine: FontDecorationToken.underline
        },
        partnerDashboardTrackStatusStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'partnerDashboardTrackStatusStackGridItems', type: WIDGET.GRIDITEM }
            ]
        },
        partnerDashboardTrackStatusStackGridItems: {
            type: GridItemTypeTokens.DASHBOARD_ITEM,
            dashboardMenuItems: trackDashboardItem,
            noOfCols: _isMobile ? 3 : 4,
            isMobile: _isMobile
        },
        partnerDashboard_partnerStack: {
            type: StackType.column,
            flex: 1,
            maxWidth: _isMobile ? 110 : 160,
            minWidth: _isMobile ? 98 : 160,
            maxHeight: _isMobile ? 110 : 160,
            minHeight: _isMobile ? 98 : 160,
            height: StackHeight.MATCH_PARENT,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL
            },
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.center,
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.Size1
                },
                borderRadius: BorderRadiusTokens.BR1
            },
            widgetItems: [
                {
                    id: 'partnerDashboard_partnerStackI1', type: WIDGET.ICON
                },
                {
                    id: 'partnerDashboard_partnerStack_Space0', type: WIDGET.SPACE
                },
                {
                    id: 'partnerDashboard_partnerStackT1', type: WIDGET.TEXT
                }
            ],
            action: {
                type: ACTION.CHANGE_TAB,
                routeId: ROUTE.PLATFORM_DASHBOARD,
                payload: {
                    routeId: ROUTE.PARTNER_REFERRED_PARTNER
                }
            }
        },
        partnerDashboard_partnerStackT1: {
            label: `Partners`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: _isMobile ? 18 : 24,
            textAlign: TextAlignTokens.center
        },
        partnerDashboard_partnerStack_Space0: {
            size: SizeTypeTokens.LG
        },
        partnerDashboard_partnerStackI1: {
            name: IconTokens.Partner3,
            size: IconSizeTokens.XXXXXL
        },
        partnerDashboardTrackStatusStackSpace2: {
            size: !_isMobile ? SizeTypeTokens.XXXL : SizeTypeTokens.LG
        },
        partnerDashboard_earningStack: {
            type: StackType.column,
            flex: 1,
            maxWidth: _isMobile ? 110 : 160,
            minWidth: _isMobile ? 98 : 160,
            maxHeight: _isMobile ? 110 : 160,
            minHeight: _isMobile ? 98 : 160,
            height: StackHeight.MATCH_PARENT,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL
            },
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.center,
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.Size1
                },
                borderRadius: BorderRadiusTokens.BR1
            },
            widgetItems: [
                {
                    id: 'partnerDashboard_earningStackI1', type: WIDGET.ICON
                },
                {
                    id: 'partnerDashboard_earningStack_Space0', type: WIDGET.SPACE
                },
                {
                    id: 'partnerDashboard_earningStackT1', type: WIDGET.TEXT
                }
            ],
            // action: {
            //   type: ACTION.CHANGE_TAB,
            //   routeId: ROUTE.PARTNER_DASHBOARD_V2,
            //   payload: {
            //     routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER
            //   }
            // }
        },
        partnerDashboard_earningStackT1: {
            label: `Earnings`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: _isMobile ? 18 : 24,
            textAlign: TextAlignTokens.center
        },
        partnerDashboard_earningStack_Space0: {
            size: SizeTypeTokens.LG
        },
        partnerDashboard_earningStackI1: {
            name: IconTokens.Earning3,
            size: IconSizeTokens.XXXXXL
        },
        partnerDashboardTrackStatusStackSpace1: {
            size: !_isMobile ? SizeTypeTokens.XXXL : SizeTypeTokens.LG
        },
        partnerDashboard_customerStack: {
            type: StackType.column,
            flex: 1,
            maxWidth: _isMobile ? 110 : 160,
            minWidth: _isMobile ? 98 : 160,
            maxHeight: _isMobile ? 110 : 160,
            minHeight: _isMobile ? 98 : 160,
            height: StackHeight.MATCH_PARENT,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL
            },
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.center,
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.Size1
                },
                borderRadius: BorderRadiusTokens.BR1
            },
            widgetItems: [
                {
                    id: 'partnerDashboard_customerStackI1', type: WIDGET.ICON
                },
                {
                    id: 'partnerDashboard_customerStack_Space0', type: WIDGET.SPACE
                },
                {
                    id: 'partnerDashboard_customerStackT1', type: WIDGET.TEXT
                }
            ],
            action: {
                type: ACTION.CHANGE_TAB,
                routeId: ROUTE.PLATFORM_DASHBOARD,
                payload: {
                    routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER
                }
            }
        },
        partnerDashboard_customerStack_Space0: {
            size: SizeTypeTokens.LG
        },
        partnerDashboard_customerStackT1: {
            label: `Customers`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: _isMobile ? 18 : 24,
            textAlign: TextAlignTokens.center
        },
        partnerDashboard_customerStackI1: {
            name: IconTokens.Customer3,
            size: IconSizeTokens.XXXXXL
        },
        partnerDashboardTrackStatusStackSpace0: {
            size: !_isMobile ? SizeTypeTokens.XXXL : SizeTypeTokens.LG
        },
        partnerDashboard_leadsStack: {
            type: StackType.column,
            flex: 1,
            height: StackHeight.MATCH_PARENT,
            maxWidth: _isMobile ? 110 : 160,
            minWidth: _isMobile ? 98 : 160,
            maxHeight: _isMobile ? 110 : 160,
            minHeight: _isMobile ? 98 : 160,
            marginRight: _isMobile ? 16 : 24,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL
            },
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.center,
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.Size1
                },
                borderRadius: BorderRadiusTokens.BR1
            },
            widgetItems: [
                {
                    id: 'partnerDashboard_leadsStackI1', type: WIDGET.ICON
                },
                {
                    id: 'partnerDashboard_leadsStack_Space0', type: WIDGET.SPACE
                },
                {
                    id: 'partnerDashboard_leadsStackT1', type: WIDGET.TEXT
                }
            ],
            action: {
                type: ACTION.CHANGE_TAB,
                routeId: ROUTE.PLATFORM_DASHBOARD,
                payload: {
                    routeId: ROUTE.PLATFORM_LEADS
                }
            }
        },
        partnerDashboard_leadsStackI1: {
            name: IconTokens.Lead3,
            size: IconSizeTokens.XXXXXL
        },
        partnerDashboard_leadsStackT1: {
            label: `Leads`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: _isMobile ? 18 : 24,
            textAlign: TextAlignTokens.center
        },
        partnerDashboard_leadsStack_Space0: {
            size: SizeTypeTokens.LG
        },
        partnerDashboardPromoCard2: {
            title: 'something',
            action: {
                type: ACTION.KNOW_MORE,
                routeId: ROUTE.PLATFORM_DASHBOARD,
                payload: {},
            },
            type: PromotionCardType.DASHBOARD_INVITE_AND_EARN,
            isCta: true,
        },
        partnerJoinedStackMobIcon1_1: {
            // name: IconTokens.GoldenThunder,
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/goldenThunder3x.png',
            aspectRatio: AspectRatioToken.A1_1,
            size: ImageSizeTokens.XXS,
            // size: IconSizeTokens.MD,
        },
        partnerDashboardBodyT1: {
            label: `TRACK STATUS`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '700',
            lineHeight: _isMobile ? 24 : 32
        },
        // StartEarningContainerGrid: <GridImageItemProps> {
        //   noOfCols: 3,
        //   type: GridItemTypeTokens.DASHBOARD_ITEM,
        //   dashboardMenuItems: startEarningItem(_link, partnerAccountType),
        //   isMobile: _isMobile
        // },
        inviteClientStack: {
            type: StackType.column,
            flex: 1,
            maxWidth: _isMobile ? 110 : 160,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL
            },
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.Size1
                },
                borderRadius: BorderRadiusTokens.BR1
            },
            widgetItems: [
                {
                    id: 'inviteClientStackI1', type: WIDGET.ICON
                },
                {
                    id: 'inviteClientStackSpace0', type: WIDGET.SPACE
                },
                {
                    id: 'inviteClientStackT1', type: WIDGET.TEXT
                }
            ],
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.INVITE_CLIENT,
                // payload: {
                //   link: _link
                // }
            }
        },
        inviteClientStackI1: {
            name: IconTokens.ShareLink2,
            size: IconSizeTokens.XXXXXL
        },
        inviteClientStackT1: {
            label: `Share unique link`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: _isMobile ? 18 : 24,
            textAlign: TextAlignTokens.center
        },
        registerClientStack: {
            type: StackType.column,
            flex: 1,
            maxWidth: _isMobile ? 110 : 160,
            padding: {
                left: SizeTypeTokens.MD,
                right: SizeTypeTokens.MD,
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL
            },
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.Size1
                },
                borderRadius: BorderRadiusTokens.BR1
            },
            widgetItems: [
                {
                    id: 'registerClientStackI1', type: WIDGET.ICON
                },
                {
                    id: 'registerClientStackSpace0', type: WIDGET.SPACE
                },
                {
                    id: 'registerClientStackT1', type: WIDGET.TEXT
                }
            ],
            action: {
                routeId: ROUTE.PLATFORM_DASHBOARD,
                type: ACTION.REGISTER_CLIENT,
                payload: {}
            }
        },
        registerClientStackI1: {
            name: IconTokens.ADD_FRIEND,
            size: IconSizeTokens.XXL
        },
        registerClientStackT1: {
            label: `Register customer`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: _isMobile ? 18 : 24,
            textAlign: TextAlignTokens.center
        },
        partnerDashboardSpace0: {
            size: SizeTypeTokens.XL
        },
        partnerDashboardSpace1: {
            size: SizeTypeTokens.XXL
        },
        partnerDashboardSpace7: {
            size: SizeTypeTokens.XL
        },
        registerClientStackSpace0: {
            size: SizeTypeTokens.LG
        },
        inviteClientStackSpace0: {
            size: SizeTypeTokens.LG
        },
        StartEarningContainerSpace0: {
            size: SizeTypeTokens.XXL
        },
        partnerJoinedMobSpace0: {
            size: SizeTypeTokens.SM,
        },
        partnerDashboardPromoSpace0: {
            size: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XL,
        },
        ...await PartnerHeader(ROUTE.PLATFORM_DASHBOARD, true),
        ...await PlatformSideNav(ROUTE.PLATFORM_DASHBOARD),
    }
});
export const platformDashboardMF = {
    onLoad: async ({ asyncStorage, network, navigate, instrumentTrack, initializeAmplitudeForPartner, openNewTab, ...props }, { setIsUserLoggedIn: boolean, isRegisterLeads, }) => {
        console.warn("Bhaavvvvvvv came inside platformDashboardMf");
        // --- Need refactor ---- //
        // const user = await sharedPropsService.getUser();
        // const dashboardActiveId = localStorage.getItem('DASHBOARD_ACTIVE_ID');
        // const accessToken = await asyncStorage.get(StoreKey.accessToken);
        //
        // if(!accessToken) {
        //   await navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab);
        //   return
        // }
        //
        // const header = await getAppHeader();
        // header["X-AppPlatform"] = 'VOLT_WEB_APP';
        // const response = await network.post(partnerApi.userContext, {}, {headers: header}, async () => {
        //   return
        // }, {
        //   isPartnerPlatform: true,
        // })
        //
        // const _user = response?.data;
        //
        // const accountId = _user?.linkedPartnerAccounts[0].accountId
        // const partnerAccountType = _user?.linkedPartnerAccounts[0]?.partnerAccountType;
        // const partnerEmail = _user?.linkedPartnerAccounts[0]?.accountHolderEmail;
        // initializeAmplitudeForPartner(accountId)
        // if(!partnerEmail) {
        //   await navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab);
        // }
        //
        // await sharedPropsService.setPartnerSideBarActiveId(dashboardActiveId);
        //
        //
        // const responseInvestorLink = await network.get(
        //     `${partnerApi.investorLink}${accountId}`,
        //     {
        //       headers: header
        //     },
        //     async () => {return},
        //     {
        //       isPartnerPlatform: true
        //     }
        // );
        //
        //
        //
        // await asyncStorage.set(StoreKey.userContext, JSON.stringify(response?.data));
        //
        //
        // const _link = responseInvestorLink.data.link;
        //
        // const partnerName = _user?.linkedPartnerAccounts[0]?.partnerName;
        // const isAccountDetailsPresent = isNull(_user?.linkedPartnerAccounts[0]?.partnerProfileDetails?.bankAccountNumber) ? false : true;
        //
        // if(isRegisterLeads) {
        //   await navigate(ROUTE.PARTNER_LEAD, {isRegisterLeads});
        // }
        //
        // if(dashboardActiveId === 'activeCustomerPage') {
        //   await navigate(ROUTE.PARTNER_ACTIVE_CUSTOMER);
        // } else if (dashboardActiveId === 'referredPartnerPage') {
        //   await navigate(ROUTE.PARTNER_REFERRED_PARTNER);
        // } else {
        //   //
        // }
        // instrumentTrack("DASHBOARD_PAGE_VIEWED")
        return Promise.resolve(template());
    },
    actions: {
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.REGISTER_CLIENT]: RegisterClient,
        [ACTION.INVITE_CLIENT]: InviteClient,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.PROMO_INVITE]: promoBannerInvite,
        [ACTION.KNOW_MORE]: onKnowMore,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.MARKETING]: goToMarketing,
        [ACTION.GO_TO_ACCOUNT_DETAIL]: goToAccountDetails
    },
};
